import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Layout from "@/pages/Layout";
import { Story } from "@/components/site/Story";
import { Acting } from "@/components/site/Acting";
import { Modeling } from "@/components/site/Modeling";
import { Activism } from "@/components/site/Activism";
import { Press } from "@/components/site/Press";
import { Contact } from "@/components/site/Contact";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/story" element={<Story />} />
          <Route path="/about" element={<Navigate to="/story" replace />} />
          <Route path="/acting" element={<Acting />} />
          <Route path="/fashion" element={<Modeling />} />
          <Route path="/modeling" element={<Navigate to="/fashion" replace />} />
          <Route path="/activism" element={<Activism />} />
          <Route path="/press" element={<Press />} />
          <Route path="/contact" element={<Contact />} />
        </Route>
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Toaster theme="light" position="bottom-right" />
    </BrowserRouter>
  );
}

export default App;
